<div *ngIf="showLoader" [@enterAnimation] id="loader"></div>
<div *ngIf="dataProd && dataProd.length > 0">
    <table class="table table-striped table-sm w-100">
        <thead class="thead-dark">
            <tr>
                <th class="d-none d-lg-table-cell" i18n="@@pl-article" scope="col">Article</th>
                <th scope="col" i18n="@@pl-title">Title</th>
                <th class="d-none text-right d-lg-table-cell" i18n="@@pl-manufacturer" scope="col">Manufacturer</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let product of dataProd">
                <td class="d-none d-lg-table-cell"><a routerLink="/product/{{ appService.getProductIdAndArticle(product.id, product.attributes ? product.attributes.article : product.article) }}"
                        
                        >{{product.attributes ? product.attributes.article : product.article}}</a> </td>
                <td>
                    <a routerLink="/product/{{ appService.getProductIdAndArticle(product.id, product.attributes ? product.attributes.article : product.article) }}"  class="d-block d-lg-none">
                    <span i18n="@@pl-article">Article</span>: {{product.attributes ?
                        product.attributes.article : product.article}} 
                        </a> 
                        
                        <span
                        [innerHTML]="product.attributes ? product.attributes.title : product.title"></span></td>
                <td class="d-none text-right d-lg-table-cell">{{product.attributes ? product.attributes.manufacturer :
                    product.manufacturer}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="mb-3" *ngIf="this.dataProd">
    <a class="btn btn-sm main-bg-color text-white  mr-2" *ngIf="showPrev" (click)="toNext = false" [routerLink]="[ '/catalog',categoryId, this.dataProd.length  > 0 ? this.dataProd[0].id : 0]" i18n="@@pl-btn-prev" > < previous</a>
    <a class="btn btn-sm main-bg-color text-white" *ngIf="showNext" (click)="toNext = true" [routerLink]="[ '/catalog',categoryId, this.dataProd.length  > 0 ? this.dataProd[this.dataProd.length - 1].id : 0] " i18n="@@pl-btn-next" > next ></a>    
</div> 